import * as React from 'react';
import './spinner.component.scss';

const Spinner = ({ className }) => <div className={`spinner ${className || ''}`} />;

export default Spinner;
